import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { oneDark } from 'react-syntax-highlighter/dist/esm/styles/prism';
import { Typography } from '@qodo/design-system';
import { CopyButton } from '../CopyButton';
import { CodeBlockProps } from './types';

export const CodeBlock = ({
  rawCode,
  displayCode,
  copyTitle,
}: CodeBlockProps) => {
  return (
    <div className="relative">
      {copyTitle && (
        <CopyButton
          value={rawCode}
          title={copyTitle}
          className="absolute top-3 right-3 hover:bg-white/10"
          iconSize="size-4"
        />
      )}
      <Typography variant="code-block" className="overflow-x-auto h-fit">
        <SyntaxHighlighter
          language="json"
          style={oneDark}
          className="m-0! p-0! bg-transparent! text-[length:inherit]! font-[inherit]!"
          codeTagProps={{
            className: 'bg-transparent! font-[inherit]!',
          }}
        >
          {displayCode}
        </SyntaxHighlighter>
      </Typography>
    </div>
  );
};
